import {useDispatch, useSelector} from "react-redux";
import React, {useState} from "react";
import {assetsUploaderToServer, createMultipleObjects, testFileTypes} from "../../../utils/helpers";
import {setAssetList, setUrlsInNewAssetList} from "../../../store/reducers/userImagesListSlice";
import {showToast} from "../../../store/reducers/notificationSlice";
import PanelImageViewer from "../../../utils/utilityComponents/PanelImagesViewer";
import {deleteAssetsImage, getGlobalAssetsData} from "../../../utils/apiHelper";

let tempArray = []

const GlobalAssetsText = () => {
    const assetsCollection = useSelector((state) => state.userImagesList).assetsTextList;
    const activeSheet = useSelector((state) => state.activeSheet).sheet;

    const [uploaderCount, setUploaderCount] = useState(0);
    const [pageCount, setPageCount] = useState(1);

    const dispatch = useDispatch()

    const inputHandler = async (event) => {
        const files = Array.prototype.slice.call(event.target.files);
        setUploaderCount(uploaderCount + 1);
        if (testFileTypes(files)) {
            const newImageList = createMultipleObjects(files.length, uploaderCount);
            dispatch(setAssetList({type: 'text_graphic', data: [...newImageList, ...assetsCollection]}));
            tempArray.push(...newImageList, ...assetsCollection);
            return new Promise(async (resolve) => {
                const resImageFiles = await assetsUploaderToServer(files, uploaderCount, dispatch, 'text_graphic');
                dispatch(setUrlsInNewAssetList({type: 'text_graphic', resImageFiles, activeSheet}));
                resolve(true);
            });
        } else {
            dispatch(showToast({message: "Upload type is not allowed!", type: "error"}));
        }
    };

    const imagesDispatcher = async (data) => {
        dispatch(setAssetList({type: 'text_graphic', data: [...assetsCollection, ...data]}));
    }

    const deleteAsset = (id) => {
        deleteAssetsImage('text_graphic', id, dispatch)
    }

    return (
        <div>
            <PanelImageViewer
                type={'text_graphic'}
                pageCount={pageCount}
                setPageCount={setPageCount}
                deleteImage={deleteAsset}
                images={assetsCollection}
                uploadBtn={'Upload Assets'}
                getImagesData={getGlobalAssetsData}
                inputHandler={inputHandler}
                imagesDispatcher={imagesDispatcher}
                classNames={'global_assets'}/>
        </div>
    );
}

export default GlobalAssetsText;
